import { makeQuery } from "src/queries/makeQuery";
import type { MinimalAppResponse } from "./apps.types";

/** GET `/api/envs/{env_name}/apps/{app_name}/info` — resolves the current
 *  route's app to its numeric env_id / app_id / tenant_id. */
export const useQueryMinimalAppInfo = makeQuery<MinimalAppResponse>(
  (p) => `/api/envs/${p.env_name}/apps/${p.app_name}/info`,
  { queryParams: ["env_name", "app_name"] }
);
